import { DateRange } from './date';

export class NotificationSearch { 
    createdDate: DateRange = DateRange.empty();
    userType = '';
    userId:any;
    tier = 'All';
    displayName = '';
    mobileNo = '';
    accountNo = '';
    emailId = '';
    agentId = '';
    branchId = '';
    field: 'tier' | 'kycStatus' = 'tier';
    value: '';
    status: any;
    id: any;
    searchType = 'mobile_no';
    type = '';
    number = '';
    appCode = '';
    module = '';
    pageSize = 5;
 }
